import { School, Users, Wallet } from 'lucide-react';
import Teacher1 from '../assets/teacher_1.png'
import Teacher2 from '../assets/teacher_2.png'
import Teacher3 from '../assets/teacher_3.png'
import Feature1 from '../assets/Feature_1.jpg'
import Feature2 from '../assets/Feature_2.jpg'
import Feature3 from '../assets/image_3.avif'
import Institution1 from '../assets/image_1.jpg'
import Institution2 from '../assets/image_2.jpg'
import Institution3 from '../assets/image_3.jpg'



export const navigationLinks = [
  //{ title: 'Why Teacher Jobs ?', href: '#why-teacher-jobs' },
  { title: 'For Teachers', href: '#for-teachers' },
  { title: 'For Institution', href: '#for-institutions' },
  { title: 'Contact Us', href: '/contact-us' },
];

export const features = [
  {
    image: Feature1,
    icon: <School className="w-8 h-8 text-blue-600" />,
    title: "India requires over one million teachers",
    description: "The education sector in India faces a significant shortage of qualified educators, creating numerous opportunities for teaching professionals."
  },
  {
    image: Feature2,
    icon: <Users className="w-8 h-8 text-blue-600" />,
    title: "Find Teachers strives to connect teachers to the right kind of opportunities",
    description: "Find Teachers strives to connect teachers to the right kind of opportunities, making the perfect match between educators and institutions."
  },
  {
    icon: <Wallet className="w-8 h-8 text-blue-600" />,
    image: Feature3,
    title: "The entire process is FREE for teachers and educational institutions.",
    description: "The entire process is FREE for teachers and educational institutions, making quality education accessible to all."
  }
];

export const howItWorks = [
  {
    image: Teacher1,
    title: 'Register Profile',
    description: 'Register yourself on FindTeachers.in'
  },
  {
    image: Teacher2,
    title: 'Explore Opportunities',
    description: 'Get notified about opportunities'
  },
  {
    image: Teacher3,
    title: 'Connect and Engage',
    description: 'Get connected to vacancies of your preference'
  }
];

export const institutionPlans = [
  {
    image: Institution1,
    title: 'Register and Upload',
    description: 'Register and Upload your vacancies',
    isPopular: true
  },
  {
    image: Institution2,
    title: 'Work with Relationship Manager',
    description: 'Work in partnership with our relationship manager for an easy onboarding process.',
    isPopular: true
  },
  {
    image: Institution3,
    title: 'Find',
    description: 'Find the best teachers for your institutions',
    isPopular: true
  }
];

export const pricingPlans = [
  {
    tier: 'Free',
    price: '0',
    features: [
      'Basic job search',
      'Profile creation',
      'Email notifications',
      'Apply to 10 jobs/month'
    ],
    buttonText: 'Get Started',
    isPopular: false
  },
  {
    tier: 'Basic',
    price: '49',
    features: [
      'Unlimited job postings',
      'Basic candidate search',
      'Email support',
      'Basic analytics'
    ],
    buttonText: 'Current Plan',
    isPopular: true
  },
  {
    tier: 'Pro',
    price: '199',
    features: [
      'Unlimited job postings',
      'Advanced candidate search',
      'Priority support',
      'Advanced analytics'
    ],
    buttonText: 'Get Started',
    isPopular: false
  }
];

export const footerLinks = {
  platform: [
    { title: 'How it Works', href: '#' },
    { title: 'Features', href: '#' },
    { title: 'FAQ', href: '#' }
  ],
  forTeachers: [
    //{ title: 'Career Resources', href: '#' },
    { title: 'Teaching Guides', href: '#' },
    { title: 'Success Stories', href: '#' }
  ],
  forInstitutions: [
    { title: 'Post a Job', href: '#' },
    { title: 'Recruitment Tools', href: '#' },
    { title: 'Success Stories', href: '#' }
  ],
  company: [
    { title: 'About Us', href: '#' },
    { title: 'Contact', href: '#' },
    { title: 'Blog', href: '#' }
  ]
};